import { apiLogger } from "../../utils/logger";import axios, { AxiosInstance } from 'axios';

// Create dedicated chat API client that uses API key authentication
const chatApiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://fabrik28.ai/api',
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for API key authentication
chatApiClient.interceptors.request.use(
  (config) => {
    const apiKey = import.meta.env.VITE_API_KEY;
    if (apiKey && config.headers) {
      config.headers.set("ApiKey", apiKey);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
chatApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle chat-specific errors if needed
    apiLogger.error('Chat API error:', error);
    return Promise.reject(error);
  }
);

export default chatApiClient;
